import IconDiscord from './IconDiscord';

export default IconDiscord;